export interface IDMResponse {
  name: string;
  value: string;
}

const includesAllowedIDMParams = (element: IDMResponse): boolean => {
  const allowed = [
    "PseudoCityCode",
    "IATAnumber",
    "AgencyRegion",
    "AgencyNACT",
    "AgencyMACT",
    "AgencyCountry",
  ];
  return allowed.includes(element.name);
};

export const filterIDMTargetingParams = (
  idmAccessGroupInfo: IDMResponse[]
): IDMResponse[] => {
  return idmAccessGroupInfo.filter(includesAllowedIDMParams);
};
